module.exports = __webpack_public_path__ + "static/media/Photo1.2c5a3bce.jpg";